import { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import ImageCard from '../../components/ImageCard/ImageCard'; // Ваш компонент из предыдущего вопроса
import './Cabinetpage.css'
import zal1 from '../../images/Cab_photos/actzal/2.jpg'
import zal2 from '../../images/Cab_photos/actzal/3.jpg'
import zal3 from '../../images/Cab_photos/actzal/4.jpg'

const CabinetPage4 = () => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState('description');
  
  const cabinetData = {
    id: 1,
    title: 'Актовый зал',
    images: [
      zal1,
      zal2,
      zal3
    ],
    description: <span><b>Актовый зал – сердце школьных событий и торжеств</b><br/> Наш актовый зал – это не просто помещение со сценой и зрительным залом, а настоящий эпицентр школьной жизни, где рождаются традиции, раскрываются таланты и происходят самые яркие события.<br/><br/> <b>Сцена для творчества и достижений</b><br/> Каждое мероприятие здесь превращается в незабываемое событие:
    <ul><li>Яркие концерты ко Дню учителя, Новому году и другим праздникам.</li>
    <li>Трогательные выпускные вечера, которые запоминаются на всю жизнь.</li>
    <li>Театральные постановки, где юные актеры раскрывают свои таланты.</li>
    <li>Тематические фестивали и творческие конкурсы.</li></ul> <br/><b>Пространство для знаний и идей</b><br/>Актовый зал служит и образовательным целям:
    <ul><li>Семинары и встречи с интересными людьми.</li>
    <li>Научные конференции и защиты проектов.</li>
    <li>Тренинги и мастер-классы для учащихся и педагогов.</li></ul><br/><b>Традиция недельных линеек</b><br/> Каждый понедельник зал собирает всю школу на традиционную линейку:
    <ul><li>Подведение итогов прошедшей недели.</li>
    <li>Награждение отличившихся учеников и классов.</li>
    <li>Анонсы предстоящих событий и важных мероприятий.</li>
    <li>Общешкольные объявления и новости.</li></ul></span>,

  };

  return (
    <div className="cabinet-page">
      
      <h1 className="cabinet-title">{cabinetData.title}</h1>
      
        <ImageCard 
          images={cabinetData.images} 
          description={'"Актовый зал – это место, где каждый ученик может почувствовать себя звездой, где рождаются школьные легенды и сохраняются самые теплые воспоминания о школьных годах."'}
        />
        <hr className='razdel'/>
      
      <div className="cabinet-content">
        {activeTab === 'description' && (
          <div className="description-section">
            <p>{cabinetData.description}</p>
          </div>
        )}
      </div>
      <div className="next-floor-button-container">
            <Link to="/" className="next-floor-button">
              На главную
            </Link>
    </div>
    </div>
  );
};

export default CabinetPage4;